import * as queryString from 'query-string';

export const useQueryString = (str: string) => {
  return queryString.parse(str);
};
